<template>
    <div>
        <div class="container-fluid position-relative bg-BAT">
            <loading v-if="loading !== 0" ></loading>
            <div class="container text-bat">
                <div class="py-4">
                    <div class="breadcrumbs-retos pb-2">
                        <a href="/home-bat">
                            <img src="/img/icons/homeBread.svg" alt="" />
                        </a>
                        <a class="link cursor-pointer" href="/novedades">Informa2 </a>
                        <a class="link cursor-pointer" :href="`/novedades?category=${this.new.category_new_id}`">{{ this.new.nameCategory }} /</a>
                        <span class="color-active-miga"><strong>{{ this.new.title }}</strong></span>
                    </div>

                    <a class="pb-2 pt-2" href="#" @click="returnBack"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
                <!-- Titulo -->
                <div class="mb-3">
                    <h1 class="text-title-bat text-indigo-darkness fs-4">
                        {{ this.new.title}}
                    </h1>
                </div>
                <!-- Descripcion -->
                <div v-if="this.new.description !== null" class="mb-5">
                    <p class="fs-6">
                        {{ this.new.description }}
                    </p>
                </div>
                <!-- Iframe Video -->
                <div v-if="this.new.link !== null" class="mb-3 d-flex justify-content-center">
                    <div class="ratio ratio-21x9 justify-content-center d-block d-md-none">
                        <iframe :src="this.new.link" title="novelty_video" allowfullscreen></iframe>
                    </div>
                    <div class="ratio ratio-21x9 w-75 justify-content-center d-none d-md-block">
                        <iframe :src="this.new.link" title="novelty_video" allowfullscreen></iframe>
                    </div>
                </div>
                <!-- Imagen -->
                <div class="mb-3 row d-flex justify-content-center">
                    <div v-if="this.new.desk_image !== null" class="col-12 col-md-8 d-flex justify-content-center mx-auto d-none d-md-block">
                        <img class="img-fluid" :src="this.new.desk_image" alt="novelty_img">
                    </div>
                    <div v-if="this.new.mobile_image !== null" class="col-12 col-md-8 d-flex justify-content-center mx-auto d-block d-md-none">
                        <img class="img-fluid" :src="this.new.mobile_image" alt="novelty_img">
                    </div>
                </div>
                <!-- Contenido Corto -->
                <div v-if="this.new.content_short !== null">
                    <span class="d-flex justify-content-center flex-column text-center" v-html="this.new.content_short"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url_media: {
            default: "",
        },
    },
    data() {
        return {
            loading: 0,
            new: null,
            id: null
        }
    },
    created() {
        const url = new URL(window.location.href);
        const pathnameParts = url.pathname.split('/');
        const lastPathnamePart = pathnameParts[pathnameParts.length - 1];
        if (!isNaN(lastPathnamePart)) {
            this.id = parseInt(lastPathnamePart);
        }
    },
    mounted () {
        this.getDetailNew(this.id)
    },
    methods: {
        getDetailNew(id){
            this.loading ++;
            console.log(this.loading)
            axios.get(`/get-new-detail/${id}`)
                .then(({data}) => {
                    this.new = data.new;
                    this.loading --;
                })
        },
        returnBack() {
            if(window.history.length > 3){
                window.history.back();
            }else{
                window.location.href = '/novedades';
            }
        },
    },
}
</script>
